/* eslint-disable max-len */
/* eslint-disable no-prototype-builtins */
/* eslint-disable arrow-body-style */

import React from 'react';
import moment from 'moment-timezone';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import owns from 'utils/objects/owns.util';

import TableClientList from 'clientCommunications/components/Campaigns/TableClientList';

const DEFAULT_PRICE_PER_TEXT = 0.06;

export class TableCampaignsResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsMonth: '',
      details: '',
    };
  }

  showDetails = (item) => {
    this.setState((current) => ({
      detailsMonth: { ...current.detailsMonth, [item]: !current.detailsMonth[item] },
    }));
  };

  showDetailsCurrentMouth = (monthMessage) => {
    const monthKey = Object.keys(this.state.detailsMonth)[0];
    const monthData = this.props.oneToOneSmsByMonth.filter((monthdata) => monthdata[0] === monthKey)[0][1];
    const clickedSMS = monthData.filter((sms) => sms.timestamp === monthMessage)[0];
    if (!clickedSMS.recipients_details) {
      this.props.showCampaignDetails(this.props.salonId, clickedSMS.id, true);
    }
    this.setState((current) => ({
      details: { ...current.details, [monthMessage]: !current.details[monthMessage] },
    }));
  };

  render() {
    const { oneToOneSmsByMonth, sortFunction, t } = this.props;
    return (
      <div className="automate-container" style={{ paddingTop: '0' }}>
        {oneToOneSmsByMonth?.length && (
          <table className="tbl-campaigns-results one-to-one-sms">
            <tbody>
              {oneToOneSmsByMonth.map(([item, value]) => {
                const calcClients = () => {
                  return value.length;
                };
                const calcSmsSent = () => {
                  return value.reduce((sms, e) => sms + e.sms_count, 0);
                };
                const calcBookings = () => {
                  return value.reduce((book, e) => book + (e.appointments_count ? e.appointments_count : 0), 0);
                };
                const calcRevenue = () => {
                  return value.reduce((rev, e) => rev + (e.revenue ? e.revenue : 0), 0).toFixed(2);
                };
                const calcSmsCost = () => {
                  return value
                    .reduce(
                      (cost, e) =>
                        cost +
                        // eslint-disable-next-line no-nested-ternary
                        (owns('cost', e)
                          ? e.cost * e.recipients.length /* * e.sms_count */
                          : 0.05 * e.recipients.length) /* * e.sms_count */,
                      0,
                    )
                    .toFixed(2);
                };
                return (
                  <tr className="tbl-row" key={item}>
                    <td className="">
                      <table className={`tbl-inner-result ${!this.state.detailsMonth[item] ? '' : 'opened'}`}>
                        <tbody>
                          <tr>
                            <td colSpan="5">
                              <div className={`visible-content ${!this.state.detailsMonth[item] ? '' : 'opened'}`}>
                                <table className="tbl-single-row">
                                  <tbody>
                                    <tr className="big-font">
                                      <td className="date-width">
                                        <div onClick={() => this.showDetails(item)} role="button" tabIndex="0">
                                          <div className="yy-mm">
                                            <span>{item}</span>
                                            <span>
                                              {!this.state.detailsMonth[item]
                                                ? t('campaigns.tableRows.viewMsg')
                                                : t('campaigns.tableRows.hideMsg')}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="target-width">{t('campaigns.tableRows.allSentMsg')}</td>
                                      <td className="message-width">
                                        <span className="f-28">{calcClients() ? calcClients() : 1}</span>
                                        <span className="d-block">{t('campaigns.tableRows.clients')}</span>
                                      </td>
                                      <td className="sms-sent-width">
                                        <span className="f-28">{calcSmsSent()}</span>
                                      </td>
                                      <td className="booking-width">
                                        <span className="f-28">{calcBookings()}</span>
                                      </td>
                                      <td className="revenue-width">
                                        <span className="f-28">
                                          <CurrencySign />
                                          {calcRevenue()}
                                        </span>
                                      </td>
                                      <td className="sms-cost-width 1">
                                        <span className="f-28">
                                          <CurrencySign />
                                          {calcSmsCost()}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              {this.state.detailsMonth[item] && (
                                <div className="hidden-content">
                                  {value &&
                                    value.map((monthMessage) => {
                                      let clientsInMouthSize = 0;
                                      if (monthMessage) {
                                        clientsInMouthSize = Object.values(monthMessage.recipients).length;
                                      }

                                      return (
                                        <div className="bucket-by-type" key={monthMessage.id}>
                                          <table className="tbl-single-row">
                                            <tbody>
                                              <tr className="big-font">
                                                <td className="date-width">
                                                  <div
                                                    // !note: deposit requested messages doesn't have id so I use timestamp
                                                    onClick={() => this.showDetailsCurrentMouth(monthMessage.timestamp)}
                                                    role="button"
                                                    tabIndex="0"
                                                  >
                                                    <div className="yy-mm">
                                                      <span>
                                                        {/* TODO: date localisation */}
                                                        {moment(monthMessage.timestamp).format('D MMMM YYYY')}
                                                      </span>
                                                      <span>
                                                        {!this.state.details[monthMessage.timestamp]
                                                          ? t('campaigns.tableRows.viewMsg')
                                                          : t('campaigns.tableRows.hideMsg')}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td className="target-width">
                                                  <span style={{ display: 'block' }}>
                                                    {monthMessage.bucket.indexOf('Booking') ? '' : monthMessage.bucket}
                                                    {monthMessage.bucket === 'all' &&
                                                      t('campaigns.tableRows.allClients')}
                                                    {monthMessage.bucket === 'cancelations' &&
                                                      t('campaigns.tableRows.cancelled')}
                                                    {monthMessage.bucket === 'invalid_patch_test' &&
                                                      t('campaigns.tableRows.patchTestClients')}
                                                    {monthMessage.bucket === 'with_phones' &&
                                                      t('campaigns.tableRows.clientsWithPhone')}
                                                    {monthMessage.bucket === 'upcoming' &&
                                                      t('campaigns.tableRows.upcomingClients')}
                                                    {monthMessage.bucket === 'first_time' &&
                                                      t('campaigns.tableRows.newClients')}
                                                    {monthMessage.bucket === 'active' &&
                                                      t('campaigns.tableRows.regularClients')}
                                                    {monthMessage.bucket === 'birthday' &&
                                                      t('campaigns.tableRows.birthdayClients')}
                                                    {monthMessage.bucket === 'lost' &&
                                                      t('campaigns.tableRows.lapsedClients')}
                                                    {monthMessage.bucket === 'deposit_requested' &&
                                                      t('campaigns.tableRows.requestedDeposit')}
                                                    {monthMessage.bucket === 'request_desposit_reminder_sent' &&
                                                      t('campaigns.tableRows.reminderDeposit')}
                                                  </span>
                                                </td>
                                                <td className="message-width">
                                                  <span className="d-inline">
                                                    {clientsInMouthSize} {t('campaigns.tableRows.clients')}
                                                  </span>
                                                </td>
                                                <td className="sms-sent-width">
                                                  <span className="f-28">{monthMessage.sms_count}</span>
                                                </td>
                                                <td className="booking-width">
                                                  <span className="f-28">{monthMessage.appointments_count}</span>
                                                </td>
                                                <td className="revenue-width">
                                                  <span className="f-28">
                                                    {monthMessage.revenue ? (
                                                      <>
                                                        <CurrencySign />
                                                        {monthMessage.revenue}
                                                      </>
                                                    ) : null}
                                                  </span>
                                                </td>
                                                <td className="sms-cost-width 1">
                                                  <span className="f-28">
                                                    {!owns('cost', monthMessage) ? (
                                                      // 0.6 is static info
                                                      <div>
                                                        <CurrencySign />
                                                        {DEFAULT_PRICE_PER_TEXT}
                                                      </div>
                                                    ) : (
                                                      <>
                                                        <CurrencySign />
                                                        {monthMessage.cost}
                                                      </>
                                                    )}
                                                  </span>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          {this.state.details[monthMessage.timestamp] && (
                                            <div className="one-to-one-border">
                                              <span className="purple label-one-to-one">
                                                {t('campaigns.tableRows.sentOn')}
                                                {S.space}
                                                {/* TODO: date localisation */}
                                                {moment(monthMessage.timestamp).format('D MMM')}
                                                {S.space}
                                                {t('campaigns.tableRows.at')}
                                                {S.space}
                                                {/* TODO: date localisation */}
                                                {moment(monthMessage.timestamp).format('h:mma')} -{S.space}
                                              </span>
                                              {monthMessage.text}
                                              {monthMessage.bucket === 'request_desposit_reminder_sent' ||
                                              monthMessage.bucket === 'deposit_requested' ? (
                                                <table className="tbl-clients-deposit-requested">
                                                  <thead>
                                                    <tr>
                                                      <th style={{ width: '200px' }}>
                                                        {t('campaigns.tableRows.clientName')}
                                                      </th>
                                                      <th style={{ width: '200px' }}>
                                                        {t('campaigns.tableRows.mobile')}
                                                      </th>
                                                      <th />
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr>
                                                      <td style={{ width: '200px' }}>
                                                        {monthMessage.recipients_details.user_name}
                                                      </td>
                                                      <td style={{ width: '200px' }}>
                                                        {monthMessage.recipients_details.phone}
                                                      </td>
                                                      <td />
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              ) : (
                                                <TableClientList
                                                  campaignId={monthMessage.id}
                                                  clients={monthMessage.clients ? monthMessage.clients : []}
                                                  wholeList
                                                  sortFunction={sortFunction}
                                                />
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

const TableCampaignsResultHoc = withTranslation()(TableCampaignsResult);

export default TableCampaignsResultHoc;
